"use client";
import React, { useState } from "react";
import SubscribeBannerText from "./SubscribeBannerText/SubscribeBannerText";
import classes from "./SubscribeBanner.module.scss";
import { useSession } from "@/lib/hooks";
import { useRouter } from "next/navigation";
import { updateSubscription } from "@/actions/fetchQueryData";

interface SubscribeBannerProps {
  style?: string;
}

function SubscribeBanner({ style }: SubscribeBannerProps) {
  const data = useSession();
  const router = useRouter();
  const [subscribed, setSubscribed] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const onSubscribeClick = () => {
    if (!data?.session?.user?.verified) {
      router.push("/login");
    }
    if (!data?.session?.user?.isSubscribed) {
      updateSubscription();
      setIsClosing(true);
      setTimeout(() => setSubscribed(true), 700);
    }
  };

  if (subscribed || data?.session?.user?.isSubscribed) return null;

  return (
    <div
      className={`${classes.banner} ${
        style === "bottom" ? classes.bottom : classes.top
      } ${isClosing ? classes.closing : ""}`}
    >
      <div className={classes["middle-section"]}>
        <SubscribeBannerText />

        <div className={classes["asteriod-btn-container"]}>
          <div className={classes["asteroids-container"]}>
            <div className={classes.asteroid}>
              <div className={classes.asteroid1}></div>
            </div>

            <div className={classes.asteroid}>
              <div className={classes.asteroid2}></div>
            </div>
          </div>

          <button className={classes.button} onClick={onSubscribeClick}>
            Subscribe
          </button>
        </div>
      </div>

    </div>
  );
}

export default SubscribeBanner;
